import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideSvgIcons, provideSvgIconsConfig, SvgIconComponent } from '@ngneat/svg-icon';
import { asAclIcon } from './icons/acl';
import { asAlertCircleIcon } from './icons/alert-circle';
import { asAlertHexagonIcon } from './icons/alert-hexagon';
import { asArchiveIcon } from './icons/archive';
import { asArrowDownIcon } from './icons/arrow-down';
import { asArrowUpIcon } from './icons/arrow-up';
import { asBaseLoadIcon } from './icons/base-load';
import { asBellIcon } from './icons/bell';
import { asBuilding01ExclIcon } from './icons/building-01-excl';
import { asBuilding01Icon } from './icons/building-01';
import { asBuilding02ExclIcon } from './icons/building-02-excl';
import { asBuilding02Icon } from './icons/building-02';
import { asBuilding03Icon } from './icons/building-03';
import { asCalendarIcon } from './icons/calendar';
import { asChatBubbleIcon } from './icons/chat-bubble';
import { asCheckIcon } from './icons/check';
import { asCheckSquareIcon } from './icons/check-square';
import { asChevronDownIcon } from './icons/chevron-down';
import { asChevronLeftIcon } from './icons/chevron-left';
import { asChevronRightIcon } from './icons/chevron-right';
import { asChevronUpIcon } from './icons/chevron-up';
import { asChevronVerticalIcon } from './icons/chevron-vertical';
import { asChipIcon } from './icons/chip';
import { asClipboardIcon } from './icons/clipboard';
import { asCogIcon } from './icons/cog';
import { asColdWaterExclIcon } from './icons/cold-water-excl';
import { asColdWaterIcon } from './icons/cold-water';
import { asColdWaterSub2ExclIcon } from './icons/cold-water-sub-2-excl';
import { asColdWaterSub2Icon } from './icons/cold-water-sub-2';
import { asColdWaterSub3ExclIcon } from './icons/cold-water-sub-3-excl';
import { asColdWaterSub3Icon } from './icons/cold-water-sub-3';
import { asColdWaterSub4ExclIcon } from './icons/cold-water-sub-4-excl';
import { asColdWaterSub4Icon } from './icons/cold-water-sub-4';
import { asColdWaterSub5ExclIcon } from './icons/cold-water-sub-5-excl';
import { asColdWaterSub5Icon } from './icons/cold-water-sub-5';
import { asColdWaterSubExclIcon } from './icons/cold-water-sub-excl';
import { asColdWaterSubIcon } from './icons/cold-water-sub';
import { asCoolingExclIcon } from './icons/cooling-excl';
import { asCoolingIcon } from './icons/cooling';
import { asCoolingSub2ExclIcon } from './icons/cooling-sub-2-excl';
import { asCoolingSub2Icon } from './icons/cooling-sub-2';
import { asCoolingSub3ExclIcon } from './icons/cooling-sub-3-excl';
import { asCoolingSub3Icon } from './icons/cooling-sub-3';
import { asCoolingSub4ExclIcon } from './icons/cooling-sub-4-excl';
import { asCoolingSub4Icon } from './icons/cooling-sub-4';
import { asCoolingSub5ExclIcon } from './icons/cooling-sub-5-excl';
import { asCoolingSub5Icon } from './icons/cooling-sub-5';
import { asCoolingSubExclIcon } from './icons/cooling-sub-excl';
import { asCoolingSubIcon } from './icons/cooling-sub';
import { asCrossIcon } from './icons/cross';
import { asCsvIcon } from './icons/csv';
import { asCustomerIcon } from './icons/customer';
import { asDotIcon } from './icons/dot';
import { asDotsIcon } from './icons/dots';
import { asDownloadIcon } from './icons/download';
import { asDropletsIcon } from './icons/droplets';
import { asEditBoxIcon } from './icons/edit-box';
import { asEnergyIcon } from './icons/energy';
import { asEnergyPerformanceCertificateIcon } from './icons/energyPerformanceCertificate';
import { asEtDeviationIcon } from './icons/et-deviation';
import { asExcelIcon } from './icons/excel';
import { asFileIcon } from './icons/file';
import { asFloorIcon } from './icons/floor';
import { asFlowIcon } from './icons/flow';
import { asFullscreenIcon } from './icons/fullscreen';
import { asGasExclIcon } from './icons/gas-excl';
import { asGasIcon } from './icons/gas';
import { asGasSub2ExclIcon } from './icons/gas-sub-2-excl';
import { asGasSub2Icon } from './icons/gas-sub-2';
import { asGasSub3ExclIcon } from './icons/gas-sub-3-excl';
import { asGasSub3Icon } from './icons/gas-sub-3';
import { asGasSub4ExclIcon } from './icons/gas-sub-4-excl';
import { asGasSub4Icon } from './icons/gas-sub-4';
import { asGasSub5ExclIcon } from './icons/gas-sub-5-excl';
import { asGasSub5Icon } from './icons/gas-sub-5';
import { asGasSubExclIcon } from './icons/gas-sub-excl';
import { asGasSubIcon } from './icons/gas-sub';
import { asHandleChevronLeftIcon } from './icons/handle-chevron-left';
import { asHandleChevronRightIcon } from './icons/handle-chevron-right';
import { asHandleHorizontalIcon } from './icons/handle-horizontal';
import { asHeatingExclIcon } from './icons/heating-excl';
import { asHeatingIcon } from './icons/heating';
import { asHeatingSub2ExclIcon } from './icons/heating-sub-2-excl';
import { asHeatingSub2Icon } from './icons/heating-sub-2';
import { asHeatingSub3ExclIcon } from './icons/heating-sub-3-excl';
import { asHeatingSub3Icon } from './icons/heating-sub-3';
import { asHeatingSub4ExclIcon } from './icons/heating-sub-4-excl';
import { asHeatingSub4Icon } from './icons/heating-sub-4';
import { asHeatingSub5ExclIcon } from './icons/heating-sub-5-excl';
import { asHeatingSub5Icon } from './icons/heating-sub-5';
import { asHeatingSubExclIcon } from './icons/heating-sub-excl';
import { asHeatingSubIcon } from './icons/heating-sub';
import { asHelpIcon } from './icons/help';
import { asHelpCircleIcon } from './icons/help-circle';
import { asHelpSquareIcon } from './icons/help-square';
import { asHome01Icon } from './icons/home-01';
import { asHotWaterExclIcon } from './icons/hot-water-excl';
import { asHotWaterIcon } from './icons/hot-water';
import { asHotWaterSub2ExclIcon } from './icons/hot-water-sub-2-excl';
import { asHotWaterSub2Icon } from './icons/hot-water-sub-2';
import { asHotWaterSub3ExclIcon } from './icons/hot-water-sub-3-excl';
import { asHotWaterSub3Icon } from './icons/hot-water-sub-3';
import { asHotWaterSub4ExclIcon } from './icons/hot-water-sub-4-excl';
import { asHotWaterSub4Icon } from './icons/hot-water-sub-4';
import { asHotWaterSub5ExclIcon } from './icons/hot-water-sub-5-excl';
import { asHotWaterSub5Icon } from './icons/hot-water-sub-5';
import { asHotWaterSubExclIcon } from './icons/hot-water-sub-excl';
import { asHotWaterSubIcon } from './icons/hot-water-sub';
import { asKpiIcon } from './icons/kpi';
import { asLineChartIcon } from './icons/line-chart';
import { asLinkExternalIcon } from './icons/link-external';
import { asListIcon } from './icons/list';
import { asLockIcon } from './icons/lock';
import { asMeterExclIcon } from './icons/meter-excl';
import { asMeterExtExclIcon } from './icons/meter-ext-excl';
import { asMeterExtIcon } from './icons/meter-ext';
import { asMeterExtSub2ExclIcon } from './icons/meter-ext-sub-2-excl';
import { asMeterExtSub2Icon } from './icons/meter-ext-sub-2';
import { asMeterExtSub3ExclIcon } from './icons/meter-ext-sub-3-excl';
import { asMeterExtSub3Icon } from './icons/meter-ext-sub-3';
import { asMeterExtSub4ExclIcon } from './icons/meter-ext-sub-4-excl';
import { asMeterExtSub4Icon } from './icons/meter-ext-sub-4';
import { asMeterExtSub5ExclIcon } from './icons/meter-ext-sub-5-excl';
import { asMeterExtSub5Icon } from './icons/meter-ext-sub-5';
import { asMeterExtSubExclIcon } from './icons/meter-ext-sub-excl';
import { asMeterExtSubIcon } from './icons/meter-ext-sub';
import { asMeterGroupIcon } from './icons/meter-group';
import { asMeterIcon } from './icons/meter';
import { asMeterSub2ExclIcon } from './icons/meter-sub-2-excl';
import { asMeterSub2Icon } from './icons/meter-sub-2';
import { asMeterSub3ExclIcon } from './icons/meter-sub-3-excl';
import { asMeterSub3Icon } from './icons/meter-sub-3';
import { asMeterSub4ExclIcon } from './icons/meter-sub-4-excl';
import { asMeterSub4Icon } from './icons/meter-sub-4';
import { asMeterSub5ExclIcon } from './icons/meter-sub-5-excl';
import { asMeterSub5Icon } from './icons/meter-sub-5';
import { asMeterSubExclIcon } from './icons/meter-sub-excl';
import { asMeterSubIcon } from './icons/meter-sub';
import { asMoneyIcon } from './icons/money';
import { asMoveHandleIcon } from './icons/move-handle';
import { asNoovaLogoIcon } from './icons/noova-logo';
import { asPeakLoadIcon } from './icons/peak-load';
import { asPencilIcon } from './icons/pencil';
import { asPlusIcon } from './icons/plus';
import { asProductionMeterExclIcon } from './icons/production-meter-excl';
import { asProductionMeterIcon } from './icons/production-meter';
import { asProductionMeterSub2ExclIcon } from './icons/production-meter-sub-2-excl';
import { asProductionMeterSub2Icon } from './icons/production-meter-sub-2';
import { asProductionMeterSub3ExclIcon } from './icons/production-meter-sub-3-excl';
import { asProductionMeterSub3Icon } from './icons/production-meter-sub-3';
import { asProductionMeterSub4ExclIcon } from './icons/production-meter-sub-4-excl';
import { asProductionMeterSub4Icon } from './icons/production-meter-sub-4';
import { asProductionMeterSub5ExclIcon } from './icons/production-meter-sub-5-excl';
import { asProductionMeterSub5Icon } from './icons/production-meter-sub-5';
import { asProductionMeterSubExclIcon } from './icons/production-meter-sub-excl';
import { asProductionMeterSubIcon } from './icons/production-meter-sub';
import { asResourceIcon } from './icons/resource';
import { asRoomIcon } from './icons/room';
import { asSearchIcon } from './icons/search';
import { asSectionIcon } from './icons/section';
import { asSignalIcon } from './icons/signal';
import { asSplitHorizontalIcon } from './icons/split-horizontal';
import { asSplitVerticalIcon } from './icons/split-vertical';
import { asSquareIcon } from './icons/square';
import { asStarFilledIcon } from './icons/star-filled';
import { asStarIcon } from './icons/star';
import { asSubscriptionsIcon } from './icons/subscriptions';
import { asSubsubMeterIcon } from './icons/subsub-meter';
import { asSubsubsubMeterIcon } from './icons/subsubsub-meter';
import { asSwitchArrowsIcon } from './icons/switch-arrows';
import { asTableIcon } from './icons/table';
import { asThermometerIcon } from './icons/thermometer';
import { asToolsIcon } from './icons/tools';
import { asTrashIcon } from './icons/trash';
import { asTrendDown01Icon } from './icons/trend-down-01';
import { asTrendUp01Icon } from './icons/trend-up-01';
import { asUnarchiveIcon } from './icons/unarchive';
import { asUsersIcon } from './icons/users';
import { asVirtualMeterIcon } from './icons/virtual-meter';
import { asWaterExclIcon } from './icons/water-excl';
import { asWaterIcon } from './icons/water';
import { asWaterSub2ExclIcon } from './icons/water-sub-2-excl';
import { asWaterSub2Icon } from './icons/water-sub-2';
import { asWaterSub3ExclIcon } from './icons/water-sub-3-excl';
import { asWaterSub3Icon } from './icons/water-sub-3';
import { asWaterSub4ExclIcon } from './icons/water-sub-4-excl';
import { asWaterSub4Icon } from './icons/water-sub-4';
import { asWaterSub5ExclIcon } from './icons/water-sub-5-excl';
import { asWaterSub5Icon } from './icons/water-sub-5';
import { asWaterSubExclIcon } from './icons/water-sub-excl';
import { asWaterSubIcon } from './icons/water-sub';
import { asZoneIcon } from './icons/zone';
import { asVirtualMeterExclIcon } from './icons/virtual-meter-excl';
import { asMeterManualIcon } from './icons/meter-manual';
import { asMeterManualSub2Icon } from './icons/meter-manual-sub-2';
import { asMeterManualSub3Icon } from './icons/meter-manual-sub-3';
import { asMeterManualSub4Icon } from './icons/meter-manual-sub-4';
import { asMeterManualSub5Icon } from './icons/meter-manual-sub-5';
import { asWaterManualIcon } from './icons/water-manual';
import { asWaterManualSub3Icon } from './icons/water-manual-sub-3';
import { asWaterManualSub2Icon } from './icons/water-manual-sub-2';
import { asWaterManualExclIcon } from './icons/water-manual-excl';
import { asWaterManualSub2ExclIcon } from './icons/water-manual-sub-2-excl';
import { asWaterManualSub3ExclIcon } from './icons/water-manual-sub-3-excl';
import { asMeterManualExclIcon } from './icons/meter-manual-excl';
import { asMeterManualSub2ExclIcon } from './icons/meter-manual-sub-2-excl';
import { asMeterManualSub3ExclIcon } from './icons/meter-manual-sub-3-excl';
import { asMeterManualSub4ExclIcon } from './icons/meter-manual-sub-4-excl';
import { asMeterManualSub5ExclIcon } from './icons/meter-manual-sub-5-excl';
import { asMeterManualSubExclIcon } from './icons/meter-manual-sub-excl';
import { asWaterManualSubIcon } from './icons/water-manual-sub';
import { asMeterManualSubIcon } from './icons/meter-manual-sub';
import { asWaterManualSubExclIcon } from './icons/water-manual-sub-excl';

/**
 * Manages all icons in the suite.
 *
 * To add an icon, first add the desired svg to ./assets.
 * Then run `bun run svg` to generate the ts icon.
 * Then add your icon to `provideSvgIcons` below.
 * You can then use icons like:
 *
 * ```html
 * <svg-icon key="star"></svg-icon>
 * ```
 */
@NgModule({
  imports: [CommonModule, SvgIconComponent],
  providers: [
    provideSvgIconsConfig({
      sizes: {
        xxs: '12px',
        xs: '16px',
        sm: '20px',
        md: '24px',
        lg: '28px',
        xl: '32px',
        xxl: '36px',
      },
      defaultSize: 'md',
    }),
    provideSvgIcons([
      asAclIcon,
      asAlertCircleIcon,
      asAlertHexagonIcon,
      asArchiveIcon,
      asArrowDownIcon,
      asArrowUpIcon,
      asBaseLoadIcon,
      asBellIcon,
      asBuilding01ExclIcon,
      asBuilding01Icon,
      asBuilding02ExclIcon,
      asBuilding02Icon,
      asBuilding03Icon,
      asCalendarIcon,
      asChatBubbleIcon,
      asCheckIcon,
      asCheckSquareIcon,
      asChevronDownIcon,
      asChevronLeftIcon,
      asChevronRightIcon,
      asChevronUpIcon,
      asChevronVerticalIcon,
      asChipIcon,
      asClipboardIcon,
      asCogIcon,
      asColdWaterExclIcon,
      asColdWaterIcon,
      asColdWaterSub2ExclIcon,
      asColdWaterSub2Icon,
      asColdWaterSub3ExclIcon,
      asColdWaterSub3Icon,
      asColdWaterSub4ExclIcon,
      asColdWaterSub4Icon,
      asColdWaterSub5ExclIcon,
      asColdWaterSub5Icon,
      asColdWaterSubExclIcon,
      asColdWaterSubIcon,
      asCoolingExclIcon,
      asCoolingIcon,
      asCoolingSub2ExclIcon,
      asCoolingSub2Icon,
      asCoolingSub3ExclIcon,
      asCoolingSub3Icon,
      asCoolingSub4ExclIcon,
      asCoolingSub4Icon,
      asCoolingSub5ExclIcon,
      asCoolingSub5Icon,
      asCoolingSubExclIcon,
      asCoolingSubIcon,
      asCrossIcon,
      asCsvIcon,
      asCustomerIcon,
      asDotIcon,
      asDotsIcon,
      asDownloadIcon,
      asDropletsIcon,
      asEditBoxIcon,
      asEnergyIcon,
      asEnergyPerformanceCertificateIcon,
      asEtDeviationIcon,
      asExcelIcon,
      asFileIcon,
      asFloorIcon,
      asFlowIcon,
      asFullscreenIcon,
      asGasExclIcon,
      asGasIcon,
      asGasSub2ExclIcon,
      asGasSub2Icon,
      asGasSub3ExclIcon,
      asGasSub3Icon,
      asGasSub4ExclIcon,
      asGasSub4Icon,
      asGasSub5ExclIcon,
      asGasSub5Icon,
      asGasSubExclIcon,
      asGasSubIcon,
      asHandleChevronLeftIcon,
      asHandleChevronRightIcon,
      asHandleHorizontalIcon,
      asHeatingExclIcon,
      asHeatingIcon,
      asHeatingSub2ExclIcon,
      asHeatingSub2Icon,
      asHeatingSub3ExclIcon,
      asHeatingSub3Icon,
      asHeatingSub4ExclIcon,
      asHeatingSub4Icon,
      asHeatingSub5ExclIcon,
      asHeatingSub5Icon,
      asHeatingSubExclIcon,
      asHeatingSubIcon,
      asHelpIcon,
      asHelpCircleIcon,
      asHelpSquareIcon,
      asHome01Icon,
      asHotWaterExclIcon,
      asHotWaterIcon,
      asHotWaterSub2ExclIcon,
      asHotWaterSub2Icon,
      asHotWaterSub3ExclIcon,
      asHotWaterSub3Icon,
      asHotWaterSub4ExclIcon,
      asHotWaterSub4Icon,
      asHotWaterSub5ExclIcon,
      asHotWaterSub5Icon,
      asHotWaterSubExclIcon,
      asHotWaterSubIcon,
      asKpiIcon,
      asLineChartIcon,
      asLinkExternalIcon,
      asListIcon,
      asLockIcon,
      asMeterExclIcon,
      asMeterExtExclIcon,
      asMeterExtIcon,
      asMeterExtSub2ExclIcon,
      asMeterExtSub2Icon,
      asMeterExtSub3ExclIcon,
      asMeterExtSub3Icon,
      asMeterExtSub4ExclIcon,
      asMeterExtSub4Icon,
      asMeterExtSub5ExclIcon,
      asMeterExtSub5Icon,
      asMeterExtSubExclIcon,
      asMeterExtSubIcon,
      asMeterGroupIcon,
      asMeterIcon,
      asMeterSub2ExclIcon,
      asMeterSub2Icon,
      asMeterSub3ExclIcon,
      asMeterSub3Icon,
      asMeterSub4ExclIcon,
      asMeterSub4Icon,
      asMeterSub5ExclIcon,
      asMeterSub5Icon,
      asMeterSubExclIcon,
      asMeterSubIcon,
      asMoneyIcon,
      asMoveHandleIcon,
      asNoovaLogoIcon,
      asPeakLoadIcon,
      asPencilIcon,
      asPlusIcon,
      asProductionMeterExclIcon,
      asProductionMeterIcon,
      asProductionMeterSub2ExclIcon,
      asProductionMeterSub2Icon,
      asProductionMeterSub3ExclIcon,
      asProductionMeterSub3Icon,
      asProductionMeterSub4ExclIcon,
      asProductionMeterSub4Icon,
      asProductionMeterSub5ExclIcon,
      asProductionMeterSub5Icon,
      asProductionMeterSubExclIcon,
      asProductionMeterSubIcon,
      asResourceIcon,
      asRoomIcon,
      asSearchIcon,
      asSectionIcon,
      asSignalIcon,
      asSplitHorizontalIcon,
      asSplitVerticalIcon,
      asSquareIcon,
      asStarFilledIcon,
      asStarIcon,
      asSubscriptionsIcon,
      asSubsubMeterIcon,
      asSubsubsubMeterIcon,
      asSwitchArrowsIcon,
      asTableIcon,
      asThermometerIcon,
      asToolsIcon,
      asTrashIcon,
      asTrendDown01Icon,
      asTrendUp01Icon,
      asUnarchiveIcon,
      asUsersIcon,
      asVirtualMeterIcon,
      asVirtualMeterExclIcon,
      asWaterExclIcon,
      asWaterIcon,
      asWaterSub2ExclIcon,
      asWaterSub2Icon,
      asWaterSub3ExclIcon,
      asWaterSub3Icon,
      asWaterSub4ExclIcon,
      asWaterSub4Icon,
      asWaterSub5ExclIcon,
      asWaterSub5Icon,
      asWaterSubExclIcon,
      asWaterSubIcon,
      asZoneIcon,
      asMeterManualIcon,
      asMeterManualSubIcon,
      asMeterManualSub2Icon,
      asMeterManualSub3Icon,
      asMeterManualSub4Icon,
      asMeterManualSub5Icon,
      asWaterManualIcon,
      asWaterManualSubIcon,
      asWaterManualSub2Icon,
      asWaterManualSub3Icon,
      asMeterManualExclIcon,
      asMeterManualSubExclIcon,
      asMeterManualSub2ExclIcon,
      asMeterManualSub3ExclIcon,
      asMeterManualSub4ExclIcon,
      asMeterManualSub5ExclIcon,
      asWaterManualExclIcon,
      asWaterManualSubExclIcon,
      asWaterManualSub2ExclIcon,
      asWaterManualSub3ExclIcon,
    ]),
  ],
  exports: [SvgIconComponent],
})
export class IconModule {}
